import React from 'react';
import { Calendar } from '@/components/Icons/Calendar';
import { Radio } from '@/components/Radio';
import { formatPeriodRange } from '@/pages/Overview/period';
import type { StudyYearPeriod } from '@/types/overview';

interface Props {
  period: StudyYearPeriod;
  isSelected: boolean;
  onSelect: (period: StudyYearPeriod) => void;
}

export const PeriodCard: React.FC<Props> = ({
  period,
  isSelected,
  onSelect,
}) => (
  <button
    type="button"
    onClick={() => onSelect(period)}
    className="group flex w-full cursor-pointer items-center gap-3 rounded-xl bg-popover px-4 py-3 text-left shadow-card transition-colors active:bg-hover"
  >
    <span className="flex size-8 shrink-0 items-center justify-center rounded-2xl bg-info-surface text-primary">
      <Calendar className="size-4" />
    </span>
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <span className="truncate text-subhead-14 text-foreground transition-colors group-hover:text-primary">
        {period.name}
      </span>
      <span className="text-body-13 truncate text-subtle-foreground transition-colors group-hover:text-primary md:text-caption-12">
        {formatPeriodRange(period)}
      </span>
    </div>
    <Radio checked={isSelected} />
  </button>
);
